import { findIndexByPropertyValue } from 'utilities/collection';

export function stringsToOptions(strings) {

  const options = [];

  for (let string of strings) {

    options.push({
      label: string,
      key: string
    });

  }

  return options;

}

export function collectionToOptions(collection, labelProperty, keyProperty) {

  const options = [];

  for (let object of collection) {

    const option = {
      label: object[labelProperty],
      key: object[keyProperty],
      object
    };

    options.push(option);

  }

  return options;

}

export function findSelectedEntryIndex(selectedEntries, entry) {

  return findIndexByPropertyValue(selectedEntries, 'key', entry.key);

}